import styled from 'styled-components';
import { Text12Light, Text14Bold, Text14Regular } from '../../../components/utils/Text/Text.styles';
import Input from '../../../components/utils/inputs/Input/Input';

export const PageContainer = styled.div`
  max-height: 100%;
  height: 100%;
  position: relative;
`;

export const Content = styled.div`
  overflow: auto;
  align-content: flex-end;
  padding: 1.6rem;
  height: 100%;
  max-height: ${({ $footerHeight, $compact }) => `calc(100% - ${$footerHeight}px - ${$compact ? '5.6rem' : '9rem'})`};
  background: #f9fafb;
`;

export const Header = styled.div`
  height: ${({ $compact }) => ($compact ? '5.6rem' : '9rem')};
  padding: 0 2.4rem 0 1.2rem;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const HeaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
`;

export const AddToGroupButton = styled.button`
  border-radius: 12px;
  border: 1px solid #d2d6db;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.02);
  padding: 0.8rem 1.2rem 0.8rem 1.2rem;
  display: flex;
  gap: 1rem;
  font-size: 1.4rem;
  font-weight: 400;
  min-height: 3.8rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
`;

export const HeaderChatInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const HeaderText = styled(Text14Regular)`
  letter-spacing: -0.42px;
  opacity: 0.4;
`;

export const HeaderTextBold = styled(Text14Bold)`
  letter-spacing: -0.42px;
`;

export const Line = styled.div`
  border-radius: 100px;
  opacity: 0.89;
  background: #d2d6db;
  height: 2rem;
  width: 1px;
`;

export const Avatar = styled.div`
  border-radius: 1000px;
  border: 1px solid #fff;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.2rem;
  height: 3.2rem;
  color: #092f4d;
  text-align: center;
  font-size: 1.2rem;
  font-weight: 600;
  letter-spacing: -0.12px;
`;

export const Footer = styled.form`
  padding: 1.6rem 2.4rem 1.6rem 2.4rem;
  border-top: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const FooterButton = styled.button`
  min-width: 4.6rem;
  height: 4.6rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $active }) => ($active ? 'linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%)' : '#f5f5f5')};
  position: relative;
  &:disabled {
    opacity: 0.2;
  }
`;

export const AiSuggestionsButtonWrapper = styled.div`
  position: relative;
  align-self: flex-start;
  height: 4.6rem;
`;

export const AiSuggestionsMenu = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.6rem 0.6rem 1.4rem 0.6rem;
  z-index: 1000;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
  pointer-events: none;

  &::before {
    content: '';
    position: absolute;
    inset: 0 0 0.8rem 0;
    border-radius: 1.2rem;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    z-index: -1;
  }

  ${AiSuggestionsButtonWrapper}:hover & {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
`;

export const AiSuggestionsMenuItem = styled.button`
  background: #f5f5f5;
  border: none;
  border-radius: 0.8rem;
  padding: 0.8rem 1.2rem;
  font-size: 1.3rem;
  font-weight: 500;
  color: #1672ba;
  cursor: pointer;
  white-space: nowrap;
  text-align: left;

  &:hover {
    background: linear-gradient(93deg, #3e9be4 6.75%, #1672ba 93.25%);
    color: #fff;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  background-color: red;
  width: 1.6rem;
  height: 1.6rem;
  border-radius: 50%;
  right: 0rem;
  top: 0rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const VipButton = styled.button`
  border-radius: 16px;
  border: 1px solid #97c9f1;
  height: 4.8rem;
  padding-inline: 1.6rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background-color: #fff;
`;

export const PriceInput = styled(Input)`
  min-width: 9.5rem;
  width: 9.5rem;
`;

export const MessageRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $role }) => ($role === 'USER' ? 'flex-start' : 'flex-end')};
  margin-bottom: 16px;
  position: relative;
`;

export const MessageBubbleWrapper = styled.div`
  display: flex;
  flex-direction: ${({ $role }) => ($role === 'USER' ? 'row' : 'row-reverse')};
  align-items: center;
  gap: 0.8rem;
  max-width: 65%;
`;

export const AlertButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
`;

export const ChatterAvatarWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  align-self: flex-end;
`;

export const ChatterAvatar = styled.span`
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50%;
  background-color: #3e9be4;
  color: #fff;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  user-select: none;
`;

export const ChatterAvatarTooltip = styled(Text14Regular)`
  position: absolute;
  bottom: 0;
  right: calc(100% + 0.6rem);
  border-radius: 0.8rem;
  background: #3e9be4;
  color: #fff;
  padding: 0.6rem 1rem;
  line-height: 1.4;
  white-space: nowrap;
  visibility: hidden;
  pointer-events: none;
  z-index: 1000;

  ${ChatterAvatarWrapper}:hover & {
    visibility: visible;
  }
`;

export const MessageBubble = styled.div`
  background-color: ${({ $role, $pending }) => ($pending ? '#dddddd' : $role === 'USER' ? '#ffffff' : '#BADAF7')};
  color: #000;
  border-radius: 12px;
  padding: 10px 16px 18px 16px;
  line-height: 1.4;
  position: relative;
  box-shadow: ${({ role }) => (role === 'USER' ? '0 1px 2px rgba(0, 0, 0, 0.08)' : '0 1px 2px rgba(0, 0, 0, 0.12)')};
  font-size: 16px;
  font-weight: 400;
  min-width: ${({ $isAudio }) => ($isAudio ? '11rem' : '6.3rem')};
  word-wrap: break-word;
  border: 2px solid ${({ $highlighted }) => ($highlighted ? '#DC2626' : 'transparent')};
`;

export const MessageSpinner = styled.img`
  width: 2.4rem;
  height: 2.4rem;
  position: absolute;
  left: -3rem;
  top: 1.4rem;
`;

export const VoiceResponseText = styled(Text12Light)`
  position: absolute;
  bottom: 0.4rem;

  left: ${({ $role }) => $role === 'INFLUENCER' && '1.6rem'};
  right: ${({ $role }) => $role === 'USER' && '1.6rem'};
`;

export const TimeText = styled(Text12Light)`
  font-weight: ${$purchased => !$purchased && '600'};
`;

export const MessageTimeText = styled(Text12Light)`
  position: absolute;
  bottom: 0.4rem;
  left: ${({ $role }) => $role === 'USER' && '1.6rem'};
  right: ${({ $role }) => $role === 'INFLUENCER' && '1.6rem'};
`;

export const DateDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  margin: 2.4rem 0;

  p {
    opacity: 0.4;
    letter-spacing: -0.42px;
  }
`;

export const DateDividerLine = styled.div`
  flex: 1;
  background: #d2d6db;
  height: 1px;
`;

export const InfiniteScrollMarker = styled.div`
  height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5rem;
`;

export const SelectedMediaContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 0.2rem;
`;

export const FooterContent = styled.div`
  display: flex;
  gap: 1.2rem;
`;

export const ClearMediaText = styled(Text14Regular)`
  cursor: pointer;
  text-decoration-line: underline;
  color: #1672ba;
  user-select: none;
`;

export const MediaWrapper = styled.div`
  width: 20rem;
  background-color: ${({ $role }) => ($role === 'USER' ? '#ffffff' : '#badaf7')};
  box-shadow: ${({ role }) => (role === 'USER' ? '0 1px 2px rgba(0, 0, 0, 0.08)' : '0 1px 2px rgba(0, 0, 0, 0.12)')};
  padding: 0.4rem 0.4rem 2.6rem 0.4rem;
  border-radius: 1.2rem;
  position: relative;
  cursor: pointer;
`;

export const PlayIconWrapper = styled.div`
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  /* background: rgba(0, 0, 0, 0.56); */
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const MediaFooter = styled.div`
  position: absolute;
  bottom: 0.4rem;
  left: ${({ $role }) => $role === 'USER' && '1.6rem'};
  right: ${({ $role }) => $role === 'INFLUENCER' && '1.6rem'};
  display: flex;
  align-items: center;
  justify-content: ${({ $role }) => ($role === 'USER' ? 'flex-start' : 'flex-end')};
  gap: 0.4rem;
`;

export const DotText = styled.p`
  font-size: 11px;
  opacity: 0.5;
  font-weight: 400;
  line-height: 13px;
`;

export const PinWrapper = styled.button`
  background-color: transparent;
  border: none;
`;

export const CostWrapper = styled.div`
  position: absolute;
  top: 0.8rem;
  left: 0.8rem;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 0.4rem 0.8rem;
  border-radius: 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  z-index: 100;
`;

export const NewMessagesContainer = styled.div`
  position: absolute;
  bottom: ${({ $footerHeight }) => `calc(${$footerHeight}px + 1.6rem)`};
  left: 1.6rem;
  background-color: #badaf7;
  padding: 1.2rem 1.6rem;
  border-radius: 12px;
  cursor: pointer;
`;

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
